import { AssistantStatus } from '../../../hooks/assistant/use-assistant-status';

const TOOL_STATUS_KEYS: Record<string, string> = {
  LIST_ACCOUNTS: 'ASSISTANT_TOOL_ACCOUNTS',
  LIST_CATEGORIES: 'ASSISTANT_TOOL_CATEGORIES',
  LIST_TRANSACTIONS: 'ASSISTANT_TOOL_TRANSACTIONS',
  GET_TRANSACTIONS_SUMMARY: 'ASSISTANT_TOOL_TRANSACTIONS_SUMMARY',
  GET_MONTH_SUMMARY: 'ASSISTANT_TOOL_MONTH',
  GET_YEAR_SUMMARY: 'ASSISTANT_TOOL_YEAR',
};

/** The translation key that says what a tool is doing, or a general one for a tool not known here. */
function toolStatusKey(toolName: string): string {
  return TOOL_STATUS_KEYS[toolName] ?? 'ASSISTANT_TOOL_OTHER';
}

/** The translation key that says what the assistant is doing. */
export default function statusKey(status: AssistantStatus): string {
  switch (status.phase) {
    case 'consulting':
      return toolStatusKey(status.tool);
    case 'analysing':
      return 'ASSISTANT_ANALYSING';
    case 'thinking':
      return 'ASSISTANT_THINKING';
  }
}
